import React from "react";
import PropTypes from "prop-types";
import TrackingLink from "theme/components/atoms/Typography/Link/TrackingLink";
import { FormattedMessage } from "react-intl";
import { ProductPrice } from "theme/components/atoms/Typography/Price";
import { useLocation } from "react-router";
import RatingAverage from "theme/modules/Reviews/RatingAverage";
import useFullUrl from "web/core/shop/useFullUrl";

const ProductOverview = ({ product, products, index, breadcrumb }) => {
  const location = useLocation();
  const seoUrl = useFullUrl(product.path);

  return (
    <div className="product-overview">
      <meta itemProp="sku" content={product.sku} />
      <div className="product-overview__name" itemProp="name">
        <TrackingLink
          eventName="Product Clicked"
          eventPayload={{ sku: product.sku, name: product.name }}
          to={{
            pathname: product.path,
            state: location
              ? {
                  returnTo: `${location.pathname}${location.search}`,
                  products:
                    products &&
                    products.map(({ sku, path }) => ({ sku, path })),
                  selected: index,
                  breadcrumb: breadcrumb,
                }
              : { breadcrumb: breadcrumb },
          }}
          clickType="block"
        >
          {product.name}
        </TrackingLink>
      </div>
      {product?.reviewsLayer?.total > 0 ? (
        <div className="product-overview__rating">
          <RatingAverage
            itemProp="aggregateRating"
            reviewsLayer={product.reviewsLayer}
            size="small"
          />
        </div>
      ) : null}
      <div
        className="product-overview__price"
        itemProp="offers"
        itemScope
        itemType="http://schema.org/Offer"
      >
        <meta itemProp="url" content={seoUrl} />
        {product.stock.isInStock ? (
          <ProductPrice prices={product.prices} />
        ) : (
          <div className="product-overview__sold-out">
            <FormattedMessage
              id="modules.ProductView.Overview.outOfStock"
              defaultMessage="Out of stock"
            />
          </div>
        )}
      </div>
    </div>
  );
};

ProductOverview.propTypes = {
  product: PropTypes.object.isRequired,
  products: PropTypes.array,
  breadcrumb: PropTypes.array,
  index: PropTypes.number,
};

export default ProductOverview;
